// Campo de formulário acessível (rótulo, dica e erro ligados por id) para os diálogos de identidade.
import type { ReactNode } from 'react';

export interface FormFieldProps {
  readonly id: string;
  readonly label: string;
  readonly hint?: string | undefined;
  readonly error?: string | undefined;
  readonly children: ReactNode;
}

export function FormField({ id, label, hint, error, children }: FormFieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="text-body font-medium">
        {label}
      </label>
      {children}
      {hint && !error && (
        <p id={`${id}-hint`} className="text-caption text-muted-foreground">
          {hint}
        </p>
      )}
      {error && (
        <p id={`${id}-error`} role="alert" className="text-caption text-destructive">
          {error}
        </p>
      )}
    </div>
  );
}

export const selectClassName =
  'h-9 w-full rounded-card border border-input bg-background px-3 text-body focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 outline-none';
